import type { IAppsDownloadsAndEngagementFilter } from "../../types/commonFiltersDto";
import type { IAppsAndroidDownloadsAndEngagementDescriptionDto } from "../../types/descriptionDto";
import { BaseDownloadsAndEngagementFilter } from "../DownloadEngagementFilter/BaseDownloadEngagementFilter";

export default class FindAndroidDownloadAndEngagementFilter extends BaseDownloadsAndEngagementFilter<
    IAppsDownloadsAndEngagementFilter,
    IAppsAndroidDownloadsAndEngagementDescriptionDto
> {}
